/**
 * Check if an object has the given property in a type-safe way.
 */
export default function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}